import React, { useCallback, useState, useEffect } from 'react';
import '../../styles/testimonials/testimonials.scss';
import TestimonialCard from './TestimonialCard'
import { motion, AnimatePresence } from 'framer-motion'
import { ArrowForward, ArrowBack } from '@mui/icons-material';

const bryan = require('../../assets/testimonials/bryanHeadshot.webp');
const hannah = require('../../assets/testimonials/hannah.webp');
const grant = require('../../assets/testimonials/grantHeadshot-min.webp');
const maxwell = require('../../assets/testimonials/maxwell.webp');
const izuka = require('../../assets/testimonials/izuka.webp');
const simmone = require('../../assets/testimonials/simmone.webp');

const testimonialInfo = [
    {
        key: 'bryan',
        photo: bryan,
        text: '"Renting with Intern.House was extremely easy and stress-free. The Intern.House team are super responsive and do their best to accommodate any requests. I would highly recommend staying here if you have a Tesla internship."',
        name: 'Bryan',
        house: 'Tesla, Fall 2022'
    },
    {
        key: 'hannah',
        photo: hannah,
        text: '"Living in an intern house was the best decision I could\'ve made when working at Tesla. Their team is amazingly helpful and super responsive, and living with other interns and getting a built-in friend group was so fun!"',
        name: 'Hannah',
        house: 'Tesla, Fall 2021'
    },
    {
        key: 'grant',
        photo: grant,
        text: '"The best part about internships are the people. This is a great way to meet amazing people in a new environment. I loved my time here and highly recommend an intern house."',
        name: 'Grant',
        house: 'Tesla, Spring 2022 and Spring 2023'
    },
    {
        key: 'maxwell',
        photo: maxwell,
        text: '"Intern.house made it super easy to focus on my internship and not need to worry about furnishing a room, looking for cooking supplies, or any of the other tasks that typically come when moving into a new house!"',
        name: 'Maxwell',
        house: 'AMD, Fall 2024'
    },
    {
        key: 'izuka',
        photo: izuka,
        text: '"Very attentive and responsive management!"',
        name: 'Izuka',
        house: 'Tesla, Summer 2024'
    },
    {
        key: 'andrew',
        photo: null,
        text: '"The intern house I stayed at was a super great living situation for the past 5 months. They were able to match my lease to the exact dates I needed to be there and I was super close to the factory making it easy to get to work."',
        name: 'Andrew',
        house: 'Tesla, Summer 2024'
    },
    {
        key: 'nathan',
        photo: null,
        text: '"InternHouse made my internship experience very easy. The whole process is very simple. I recommend this route for anybody interning at Tesla."',
        name: 'Nathan',
        house: 'Tesla, Spring 2024'
    },
    {
        key: 'simmone',
        photo: simmone,
        text: '"House is amazing!! Honestly it helps so much to live with other interns, make friends, and live so close to work :) they are very attentive landlords and very accommodating - very trustworthy and would def stay again"',
        name: 'Simmone',
        house: 'Tesla, Spring 2024'
    },
    {
        key: 'bishal',
        photo: null,
        text: '"Best place to live and have fun while you\'re interning at Tesla"',
        name: 'Bishal',
        house: 'Tesla, Spring 2024'
    },
    {
        key: 'bansari',
        photo: null,
        text: '"I chose to stay here twice during my period at Austin and had a great experience. Brian made it real easy and they maintain the properties really well. I would recommend choosing Intern house if you are new in town or looking for a stress free environment and hassle free stay."',
        name: 'Bansari',
        house: 'AMD, Fall 2023 and Fall 2024'
    },
    {
        key: 'ipsita',
        photo: null,
        text: '"Living in an intern house took so much stress away from my move to Texas. They are so friendly, reasonable, and quick to respond. I was even able to meet some great interns and make friends before work even started."',
        name: 'Ipsita',
        house: 'Tesla, Fall 2023'
    },
    {
        key: 'justin',
        photo: null,
        text: '"Extremely convenient commuting to Tesla. Great experience to live with other interns and the house was in great condition."',
        name: 'Justin',
        house: 'Tesla, Fall 2023'
    },
    {
        key: 'nolan',
        photo: null,
        text: '"I found intern.house when I needed a place FAST. Everywhere else I looked at was either unfurnished, in bad shape, or both. They were extremely helpful in getting me to a great place on a tight timeline"',
        name: 'Nolan',
        house: 'Tesla, Fall 2023'
    },
    {
        key: 'sebastian',
        photo: null,
        text: '"I really enjoyed meeting and living with other interns from Tesla who have become lifelong friends of mine. The easy move-in & move-out made it super easy to settle in Austin."',
        name: 'Sebastian',
        house: 'Tesla, Summer 2023'
    },
    {
        key: 'lana',
        photo: null,
        text: '"Intern house was a great experience! I met a lot of friends that I otherwise wouldn\'t have had, and it was a super easy process!"',
        name: 'Lana',
        house: 'AMD, Summer 2024'
    }
];

const Testimonials = () => {
    
    // State for carousel
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    const [randomizedTestimonials, setRandomizedTestimonials] = useState([]);
    
    // Randomize testimonials order on mount
    useEffect(() => {
        // Fisher-Yates shuffle algorithm
        const shuffled = [...testimonialInfo];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        setRandomizedTestimonials(shuffled);
    }, []);
    
    const handlePrevious = useCallback(() => {
        if (randomizedTestimonials.length === 0) return;
        setCurrentIndex((prevIndex) => 
            prevIndex === 0 ? randomizedTestimonials.length - 1 : prevIndex - 1
        );
        setIsAutoPlaying(false);
        setTimeout(() => setIsAutoPlaying(true), 120000); // Resume auto-play after 2 minutes
    }, [randomizedTestimonials.length]);
    
    const handleNext = useCallback((pauseAutoPlay = true) => {
        if (randomizedTestimonials.length === 0) return;
        setCurrentIndex((prevIndex) => 
            (prevIndex + 1) % randomizedTestimonials.length
        );
        if (pauseAutoPlay) {
            setIsAutoPlaying(false);
            setTimeout(() => setIsAutoPlaying(true), 120000); // Resume auto-play after 2 minutes
        }
    }, [randomizedTestimonials.length]);

    // Auto-play functionality
    useEffect(() => {
        if (!isAutoPlaying) return;
        const interval = setInterval(() => {
            handleNext(false);
        }, 5000); // Change slide every 5 seconds

        return () => clearInterval(interval);
    }, [handleNext, isAutoPlaying]);
    
    // Get the 3 testimonials to display
    const getVisibleTestimonials = () => {
        if (randomizedTestimonials.length === 0) return [];
        const testimonials = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % randomizedTestimonials.length;
            testimonials.push(randomizedTestimonials[index]);
        }
        return testimonials;
    };
    
    const visibleTestimonials = getVisibleTestimonials();
    
    // Don't render until testimonials are randomized
    if (randomizedTestimonials.length === 0) {
        return null;
    }

    return(
        <div id='testimonials-layout'>
            <h1 id='testimonials-title'>Testimonials</h1>
            <div id='testimonials-carousel-container'>
                <button 
                    className='carousel-nav-button carousel-nav-prev'
                    onClick={handlePrevious}
                    aria-label="Previous testimonials"
                >
                    <ArrowBack />
                </button>
                
                <div id='card-layout'>
                    <AnimatePresence mode='wait'>
                        {visibleTestimonials.map((testimonial, index) => (
                            <motion.div
                                key={`${testimonial.key}-${currentIndex}-${index}`}
                                initial={{ opacity: 0, x: 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -100 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >
                                <TestimonialCard 
                                    id={testimonial.key} 
                                    photo={testimonial.photo} 
                                    text={testimonial.text} 
                                    name={testimonial.name} 
                                    house={testimonial.house} 
                                />
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>
                
                <button 
                    className='carousel-nav-button carousel-nav-next'
                    onClick={handleNext}
                    aria-label="Next testimonials"
                >
                    <ArrowForward />
                </button>
            </div>
        </div>
    );
}


export default Testimonials;
